'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/inherits");

var leftPad = require('left-pad');

var whilst = require('async/whilst');

var waterfall = require('async/waterfall');

var CID = require('cids');

var dagPB = require('ipld-dag-pb');

var UnixFS = require('ipfs-unixfs');

var DAGLink = dagPB.DAGLink;
var DAGNode = dagPB.DAGNode;

var multihashing = require('multihashing-async');

var Dir = require('./dir');

var Bucket = require('../hamt');

var hashFn = function hashFn(value, callback) {
  multihashing(value, 'murmur3-128', function (err, hash) {
    if (err) {
      callback(err);
    } else {
      // Multihashing inserts preamble of 2 bytes. Remove it.
      // Also, murmur3 outputs 128 bit but, accidently, IPFS Go's
      // implementation only uses the first 64, so we must do the same
      // for parity..
      var justHash = hash.slice(2, 10);
      var length = justHash.length;
      var result = Buffer.alloc(length); // TODO: invert buffer because that's how Go impl does it

      for (var i = 0; i < length; i++) {
        result[length - i - 1] = justHash[i];
      }

      callback(null, result);
    }
  });
};

hashFn.code = 0x22; // TODO: get this from multihashing-async?

var defaultOptions = {
  hashFn: hashFn
};

var DirSharded =
/*#__PURE__*/
function (_Dir) {
  _inherits(DirSharded, _Dir);

  function DirSharded(props, _options) {
    var _this;

    _classCallCheck(this, DirSharded);

    var options = Object.assign({}, defaultOptions, _options);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirSharded).call(this, props, options));
    _this._bucket = Bucket(options);
    return _this;
  }

  _createClass(DirSharded, [{
    key: "put",
    value: function put(name, value, callback) {
      this._bucket.put(name, value, callback);
    }
  }, {
    key: "get",
    value: function get(name, callback) {
      this._bucket.get(name, callback);
    }
  }, {
    key: "childCount",
    value: function childCount() {
      return this._bucket.leafCount();
    }
  }, {
    key: "directChildrenCount",
    value: function directChildrenCount() {
      return this._bucket.childrenCount();
    }
  }, {
    key: "onlyChild",
    value: function onlyChild(callback) {
      this._bucket.onlyChild(callback);
    }
  }, {
    key: "eachChildSeries",
    value: function eachChildSeries(iterator, callback) {
      this._bucket.eachLeafSeries(iterator, callback);
    }
  }, {
    key: "flush",
    value: function flush(path, ipld, source, callback) {
      var _this2 = this;

      _flush(this._options, this._bucket, path, ipld, source, function (err, node) {
        if (err) {
          callback(err);
        } else {
          _this2.multihash = node.multihash;
          _this2.size = node.size;
        }

        callback(null, node);
      });
    }
  }]);

  return DirSharded;
}(Dir);

module.exports = createDirSharded;

function createDirSharded(props, _options) {
  return new DirSharded(props, _options);
}

function _flush(options, bucket, path, ipld, source, callback) {
  var children = bucket._children; // TODO: intromission

  var index = 0;
  var links = [];
  whilst(function () {
    return index < children.length;
  }, function (callback) {
    var child = children.get(index);

    if (child) {
      collectChild(child, index, function (err) {
        index++;
        callback(err);
      });
    } else {
      index++;
      callback();
    }
  }, function (err) {
    if (err) {
      callback(err);
      return; // early
    }

    haveLinks(links);
  });

  function collectChild(child, index, callback) {
    var labelPrefix = leftPad(index.toString(16).toUpperCase(), 2, '0');

    if (Bucket.isBucket(child)) {
      _flush(options, child, path, ipld, null, function (err, node) {
        if (err) {
          callback(err);
          return; // early
        }

        links.push(new DAGLink(labelPrefix, node.size, node.multihash));
        callback();
      });
    } else {
      var value = child.value;
      var label = labelPrefix + child.key;
      links.push(new DAGLink(label, value.size, value.multihash));
      callback();
    }
  }

  function haveLinks(links) {
    // go-ipfs uses little endian, that's why we have to
    // reverse the bit field before storing it
    var data = Buffer.from(children.bitField().reverse());
    var dir = new UnixFS('hamt-sharded-directory', data);
    dir.fanout = bucket.tableSize();
    dir.hashType = options.hashFn.code;
    waterfall([function (callback) {
      return DAGNode.create(dir.marshal(), links, options.hashAlg, callback);
    }, function (node, callback) {
      if (options.onlyHash) return callback(null, node);
      var cid = new CID(node.multihash);

      if (options.cidVersion === 1) {
        cid = cid.toV1();
      }

      ipld.put(node, {
        cid: cid
      }, function (err) {
        return callback(err, node);
      });
    }, function (node, callback) {
      var pushable = {
        path: path,
        multihash: node.multihash,
        size: node.size
      };

      if (source) {
        source.push(pushable);
      }

      callback(null, node);
    }], callback);
  }
}